// extracted by mini-css-extract-plugin
export default {"wrapper":"TeamViewerSupport_wrapper__5089f","itemWrapper":"TeamViewerSupport_itemWrapper__des+I","item":"TeamViewerSupport_item__9ffSj","mobile":"TeamViewerSupport_mobile__bf5EC"};